module.exports = __webpack_public_path__ + "img/accessory_shoe_03.75d353ed.svg";